import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import palette from '@ui/palette';
import { useIsTrialUser } from 'context/user/UserContext';

import CounterDropdownMenu from '../../../Account/Usage/CounterDropdownMenu';
import UpgradeHeaderButton from '../../../Account/Usage/UpgradeHeaderButton';
import HeaderButtons from './ToggleRailButtons';

export const LEFT_NAVIGATION_BUTTON_OFFSET = 12;

const useStyles = makeStyles()(theme => ({
  root: {
    background: palette.gray_1100,
    borderBottom: `1px solid ${palette.gray_800}`,
    zIndex: theme.zIndex.drawer + 3,
    display: 'grid',
    gridArea: 'header',
    gridTemplateAreas: '"left content right"',
    gridTemplateColumns:
      'minmax(0, max-content) minmax(auto, 1000px) minmax(max-content, auto)',
    height: '40px',
    width: '100%',
    '&:has(:focus-visible)': {
      borderRadius: theme.spacing(0.5),
      outline: `2px solid ${palette.mint_200}`,
      outlineOffset: `-3px`,
    },
  },
  content: {
    gridArea: 'content',
  },
  right: {
    gridArea: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
  },
}));

/**
 * @description A layout component for the header of the page. This component renders the breadcrumbs of the
 *              user's current page. It also contains buttons to open the left rail (collapsing the left rail
 *              is within left rail's child component) and toggles open and close the right rail.
 */
export default function DesktopHeader({
  hideRightRailButton = false,
  children,
}: {
  hideRightRailButton?: boolean;
  children: React.ReactNode;
}) {
  const { classes } = useStyles();
  const isTrialUser = useIsTrialUser();

  return (
    <Box component="header" className={classes.root}>
      <HeaderButtons.ToggleLeftRailButton />
      <Box component="section" className={classes.content}>
        {children}
      </Box>
      <Box className={classes.right}>
        <CounterDropdownMenu />
        {isTrialUser && <UpgradeHeaderButton />}
        {!hideRightRailButton && <HeaderButtons.ToggleRightRailButton />}
      </Box>
    </Box>
  );
}
